import { useState } from 'react';
import type { ReactNode } from 'react';

import { logoutUser } from '../utils/logout';
import LogoutModal from './LogoutModal';

interface Props {
  className?: string;
  children?: ReactNode;
}

export default function LogoutButton({
  className,
  children,
}: Props) {
  const [showModal, setShowModal] = useState(false);

  const handleConfirm = async () => {
    setShowModal(false);
    await logoutUser();
  };

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => setShowModal(true)}
      >
        {children}
      </button>

      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
      />
    </>
  );
}